const STREAK_KEY = 'ota_prefetch_failure_streak'

export const STRANDED_AFTER_MS = 24 * 60 * 60 * 1000

type StreakStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

interface Streak {
  firstAt: number
  reported: boolean
}

function readStreak(storage: StreakStorage): Streak | null {
  const raw = storage.getItem(STREAK_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<Streak>
    return typeof parsed.firstAt === 'number' ? { firstAt: parsed.firstAt, reported: parsed.reported === true } : null
  } catch {
    return null
  }
}

// Each resume retries, so one failure says little: a flaky connection, or a
// throwaway install on an automated device farm (GlitchTip 8691204, #681). What's
// worth an issue is a device that stays stranded, reported once per streak.
export function shouldReportPrefetchFailure(now = Date.now(), storage: StreakStorage = localStorage): boolean {
  try {
    const streak = readStreak(storage)
    if (!streak) {
      storage.setItem(STREAK_KEY, JSON.stringify({ firstAt: now, reported: false }))
      return false
    }
    if (streak.reported || now - streak.firstAt < STRANDED_AFTER_MS) return false
    storage.setItem(STREAK_KEY, JSON.stringify({ ...streak, reported: true }))
    return true
  } catch {
    return false
  }
}

export function clearPrefetchFailures(storage: StreakStorage = localStorage): void {
  try {
    storage.removeItem(STREAK_KEY)
  } catch {
    // Nothing recorded either, then.
  }
}
